<template>
  <div class="app-slider">
    <VueSlickCarousel
      v-bind="carouselSettings"
      ref="carousel"
      :class="customTheme"
    >
      <slot />
      <template #prevArrow>
        <button alt="Previous slide">
          <font-awesome-icon icon="chevron-left" />
        </button>
      </template>
      <template #nextArrow>
        <button alt="Next slide">
          <font-awesome-icon icon="chevron-right" />
        </button>
      </template>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'AppSlider',

  components: {
    VueSlickCarousel
  },

  props: {
    theme: {
      type: String,
      default: 'purple'
    },
    slidesToShow: {
      type: Number,
      default: 2
    },
    slidesWhenNoCarousel: {
      type: Number,
      default: 3
    }
  },

  data () {
    return {
      numVisibleSlides: 0,
      carouselSettings: {
        'infinite': true,
        'slidesToShow': this.slidesWhenNoCarousel,
        'swipeToSlide': true,
        'edgeFriction': 0,
        'accessibility': true,
        'centerMode': false,
        'adaptiveHeight': false,
        'responsive': [
          {
            'breakpoint': 1366,
            'settings': {
              'slidesToShow': this.slidesToShow
            }
          },
          {
            'breakpoint': 775,
            'settings': {
              'slidesToShow': this.slidesToShow
            }
          },
          {
            'breakpoint': 599,
            'settings': {
              'slidesToShow': 1
            }
          }
        ]
      }
    }
  },

  computed: {
    customTheme () {
      return `theme-${this.theme}`
    }
  }
}
</script>
